import { render } from "./ChangeForgettedPasswordForm.vue?vue&type=template&id=076a8ddd"
import script from "./ChangeForgettedPasswordForm.vue?vue&type=script&lang=js"
export * from "./ChangeForgettedPasswordForm.vue?vue&type=script&lang=js"

import exportComponent from "/Users/zayed-lune/Desktop/Lunedata/lune-dashboard/dashboard-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/LoginFlow/ChangeForgettedPasswordForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "076a8ddd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('076a8ddd', __exports__)) {
    console.log('reload')
    api.reload('076a8ddd', __exports__)
  }
  
  module.hot.accept("./ChangeForgettedPasswordForm.vue?vue&type=template&id=076a8ddd", () => {
    console.log('re-render')
    api.rerender('076a8ddd', render)
  })

}


export default __exports__